import { createContext } from "react";

interface IBrandPageComposableTileQuickAddCallbackContext {
  onChooseMultiOption: () => void;
}
/**
 * This context is created for one-off purpose to
 *  pass in the onChooseMultiOption callback
 *  on brand page

 * - Don't pass callbacks/tracking events into this wrapper
 * - This wrapper will be REMOVED once we have done carts
 *   hook migration.
 * - Keep callbacks inside the component as much as possible, if
 *   a context is provided, use them directly inside QuickAdd.
 */
export const BrandPageComposableTileQuickAddCallbackContext =
  createContext<IBrandPageComposableTileQuickAddCallbackContext>({
    onChooseMultiOption: () => {},
  });
